import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function getVoterId() {
  let id = localStorage.getItem("iswear_voter_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("iswear_voter_id", id);
  }
  return id;
}
